import * as Yup from 'yup'

export const ManageServicesFormValidator = Yup.object().shape({
  values: Yup.array().of(
    Yup.object().shape({
      highEstimate: Yup.number().typeError('Field can not be empty').integer().min(1, 'Value can not be less than 1.')
        .nullable(true),
      lowEstimate: Yup.number().typeError('Field can not be empty').integer().min(1, 'Value can not be less than 1.')
        .nullable(true),
      midEstimate: Yup.number().typeError('Field can not be empty').integer().min(1, 'Value can not be less than 1.')
        .nullable(true),
      percentage: Yup.number().typeError('Field can not be empty').min(1, 'Value can not be less than 1.')
        .max(99, 'Value can not be more than 99').nullable(true),
    }),
  ),
})
